// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-colorful {
  width: 100% !important;
}

[data-reference-hidden] {
  opacity: 0;
  pointer-events: none;
}

::-webkit-scrollbar {
  width: 0.25rem; /* w-1 */
  height: 0.25rem; /* h-1 */
  background-color: rgba(115, 115, 115, 0.2); /* bg-neutral-500/20 */
}

::-webkit-scrollbar-thumb {
  background-color: rgba(115, 115, 115, 0.5); /* bg-neutral-500/50 */
  border-radius: 9999px; /* rounded-full */
}

input[type="range"] {
  height: 0.625rem; /* h-2.5 */
  background-color: #e5e5e5; /* bg-neutral-200 */
  border: 0;
  border-radius: 0.25rem; /* rounded */
  appearance: none;
  transition: all 0.2s ease-in-out; /* transition-all */
}

input[type="range"]:active {
  background-color: #d4d4d4; /* active:bg-neutral-300 */
}

input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 0.75rem; /* w-3 */
  height: 1.25rem; /* h-5 */
  background-color: #262626; /* bg-neutral-800 */
  border-radius: 9999px; /* rounded-full */
  transition: all 0.2s ease-in-out; /* transition-all */
}

input[type="range"]::-webkit-slider-thumb:active {
  background-color: #000000; /* active:bg-neutral-900 */
  width: 1rem; /* active:w-4 */
  height: 1.5rem; /* active:h-6 */
}

input[type="range"]::-webkit-slider-thumb.dark {
  background-color: #f5f5f5; /* dark:bg-neutral-100 */
}

input[type="range"]::-webkit-slider-thumb.dark:active {
  background-color: #ffffff; /* dark:active:bg-white */
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc,EAAE,QAAQ;EACxB,eAAe,EAAE,QAAQ;EACzB,0CAA0C,EAAE,sBAAsB;AACpE;;AAEA;EACE,0CAA0C,EAAE,sBAAsB;EAClE,qBAAqB,EAAE,iBAAiB;AAC1C;;AAEA;EACE,gBAAgB,EAAE,UAAU;EAC5B,yBAAyB,EAAE,mBAAmB;EAC9C,SAAS;EACT,sBAAsB,EAAE,YAAY;EACpC,gBAAgB;EAChB,gCAAgC,EAAE,mBAAmB;AACvD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,QAAQ;EACxB,eAAe,EAAE,QAAQ;EACzB,yBAAyB,EAAE,mBAAmB;EAC9C,qBAAqB,EAAE,iBAAiB;EACxC,gCAAgC,EAAE,mBAAmB;AACvD;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,WAAW,EAAE,eAAe;EAC5B,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;AACtD","sourcesContent":[".react-colorful {\n  width: 100% !important;\n}\n\n[data-reference-hidden] {\n  opacity: 0;\n  pointer-events: none;\n}\n\n::-webkit-scrollbar {\n  width: 0.25rem; /* w-1 */\n  height: 0.25rem; /* h-1 */\n  background-color: rgba(115, 115, 115, 0.2); /* bg-neutral-500/20 */\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgba(115, 115, 115, 0.5); /* bg-neutral-500/50 */\n  border-radius: 9999px; /* rounded-full */\n}\n\ninput[type=\"range\"] {\n  height: 0.625rem; /* h-2.5 */\n  background-color: #e5e5e5; /* bg-neutral-200 */\n  border: 0;\n  border-radius: 0.25rem; /* rounded */\n  appearance: none;\n  transition: all 0.2s ease-in-out; /* transition-all */\n}\n\ninput[type=\"range\"]:active {\n  background-color: #d4d4d4; /* active:bg-neutral-300 */\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb {\n  appearance: none;\n  width: 0.75rem; /* w-3 */\n  height: 1.25rem; /* h-5 */\n  background-color: #262626; /* bg-neutral-800 */\n  border-radius: 9999px; /* rounded-full */\n  transition: all 0.2s ease-in-out; /* transition-all */\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb:active {\n  background-color: #000000; /* active:bg-neutral-900 */\n  width: 1rem; /* active:w-4 */\n  height: 1.5rem; /* active:h-6 */\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb.dark {\n  background-color: #f5f5f5; /* dark:bg-neutral-100 */\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb.dark:active {\n  background-color: #ffffff; /* dark:active:bg-white */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
